import { CommentsSection } from "@Modules/common";
import {
    getVisitorDetails,
    createAction,
    ACTION_TYPES,
    API_ACTION_TYPES,
    useFetchStatus,
    FETCH_STATUS,
    getUserAccessToken,
    SELECTORS,
} from "@Utils";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IBlogPostComments } from "./IBlogPostComments";

export const BlogPostComments = ({
    data,
    onCreateComment,
    openBlogVisitorPopup,
    preview,
    handlePreviewPopup,
}: IBlogPostComments.IProps) => {
    const [page, setPage] = useState(0);
    const host = useSelector(SELECTORS.host);

    const fetchComments = (firstPage: boolean = false) => {
        if (preview) {
            return;
        }
        const fetchPage = firstPage ? 1 : page + 1;
        dispatch(
            createAction(ACTION_TYPES.UTILS.API_CALL, {
                apiActionType: API_ACTION_TYPES.FETCH_BLOG_POST_COMMENTS,
                urlArgs: {
                    blogPostUuid: data?.uuid,
                    page: fetchPage,
                },
                headers: {
                    "jwt-token": getUserAccessToken(),
                },
                successCallback: () => {
                    setPage(fetchPage);
                },
            })
        );
    };

    useEffect(() => {
        if (data?.uuid) {
            fetchComments();
        }
    }, [data?.uuid]);

    const dispatch = useDispatch();

    const createBlogPostComment = ({
        commentInput,
        successCallback,
        finallyCallback,
    }: {
        commentInput: string;
        successCallback?: () => void;
        finallyCallback?: () => void;
    }) => {
        if (preview) {
            handlePreviewPopup();
            return;
        }
        const visitorDetails = getVisitorDetails();
        if (!visitorDetails.uuid) {
            openBlogVisitorPopup();
            finallyCallback?.();
        } else {
            dispatch(
                createAction(ACTION_TYPES.UTILS.API_CALL, {
                    apiActionType: API_ACTION_TYPES.CREATE_BLOG_POST_COMMENT,
                    payload: {
                        post_uuid: data?.uuid,
                        content: commentInput,
                        visitor_uuid: visitorDetails.uuid,
                    },
                    successCallback: () => {
                        if (successCallback) {
                            successCallback();
                        }
                        setPage(0);
                        fetchComments(true);
                        onCreateComment();
                    },
                    finallyCallback: () => {
                        finallyCallback?.();
                    },
                })
            );
        }
    };

    const fetchCommentsStatus = useFetchStatus(
        API_ACTION_TYPES.FETCH_BLOG_POST_COMMENTS
    );

    const onLoadMoreClick = () => {
        fetchComments();
    };

    const comments = host?.blogPostComments?.data || [];

    return (
        <CommentsSection
            data={comments}
            createComment={createBlogPostComment}
            preview={preview}
            handlePreviewPopup={handlePreviewPopup}
            showLoadMoreFunctionality={
                comments.length < (host?.blogPostComments?.total || 0)
            }
            isLoading={fetchCommentsStatus === FETCH_STATUS.FETCHING}
            onLoadMoreClick={onLoadMoreClick}
            componentParent="Blog"
        />
    );
};

BlogPostComments.defaultProps = {};
